var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileCheck021(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-check-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M73.3337 45.8335V24.9335C73.3337 18.7729 73.3337 15.6926 72.1347 13.3396C71.0801 11.2698 69.3973 9.58703 67.3276 8.53242C64.9745 7.3335 61.8942 7.3335 55.7337 7.3335H32.267C26.1064 7.3335 23.0261 7.3335 20.6731 8.53242C18.6033 9.58703 16.9205 11.2698 15.8659 13.3396C14.667 15.6926 14.667 18.7729 14.667 24.9335V63.0668C14.667 69.2274 14.667 72.3077 15.8659 74.6607C16.9205 76.7305 18.6033 78.4133 20.6731 79.4679C23.0261 80.6668 26.1064 80.6668 32.267 80.6668H44.0003M51.3337 40.3335H29.3337M36.667 55.0002H29.3337M58.667 25.6668H29.3337M53.167 69.6668L60.5003 77.0002L77.0003 60.5002",
    stroke: "white",
    strokeWidth: 2.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheck021);
export default __webpack_public_path__ + "static/media/file-check-02 (1).8728638bced531501fdfaa305d542daa.svg";
export { ForwardRef as ReactComponent };